// import

import type {GetStaticPaths, GetStaticProps} from 'next';

import {revalidate} from 'libs/constants';
import db from 'libs/db';
import type {BlogMainNode, PersonNode} from 'libs/model';
import {BlogPage, BlogAuthorHeader} from 'modules/Blog';

// types

type Props = {
  main: BlogMainNode;
  person: PersonNode;
};

type Query = {
  slug: string;
};

// component

export default function BlogAuthorView(props: Props) {
  const {person, main} = props;

  return (
    <BlogPage
      small
      area={person}
      header={<BlogAuthorHeader author={person} />}
      main={main}
      posts={person.meta.nodeRefs}
    />
  );
}

// data

export const getStaticPaths: GetStaticPaths<Query> =
  async () => {
    return {
      fallback: 'blocking',
      paths: (await db.readPersons())
        .map((n) => ({params: {slug: n.meta.slug}})),
    };
  };

export const getStaticProps: GetStaticProps<Props, Query> =
  async ({preview, params: {slug} = {}}) => {
    const [person, main] = await Promise.all([
      db.readPerson(slug as string, {preview}),
      db.readBlogMain({preview}),
    ]);

    if (!person || !main) {
      return {notFound: true};
    }

    return {
      revalidate,
      props: {person, main},
    };
  };
